module.exports = __webpack_public_path__ + "static/img/burnaby1.8f4912a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/burnaby1.jpg
// module id = 75
// module chunks = 9